// Generated by ReScript, PLEASE EDIT WITH CARE


let baseRoute = "/stocktransfer";

let createRoute = baseRoute + "/create";

export {
  baseRoute,
  createRoute,
}
/* No side effect */
